import { j as t } from "./jsx-runtime-B6kdoens.js";
import { c as l, T as N } from "./logo-svg-embed-Cp82pc6m.js";
import { createRef as v, useState as b, useEffect as g } from "react";
import { FontAwesomeIcon as h } from "@fortawesome/react-fontawesome";
import "./product-utils-BZ9FKiCb.js";
import { a as T } from "./outside-click-wx59LN8I.js";
const M = () => /* @__PURE__ */ t.jsxs("span", { className: "relative-position", children: [
  /* @__PURE__ */ t.jsx("span", { className: "sr-only", children: "No Value" }),
  /* @__PURE__ */ t.jsx(h, { icon: "fa-light fa-hyphen" })
] }), R = ({ count: e, className: s }) => {
  let n = e;
  return e >= 1e6 ? n = j(e / 1e6) + "M" : e >= 1e3 ? n = j(e / 1e3) + "K" : e == 0 && (n = /* @__PURE__ */ t.jsx(M, {})), /* @__PURE__ */ t.jsx("span", { className: l(s), title: e, children: n });
};
function j(e) {
  return Math.round((e + Number.EPSILON) * 100) / 100;
}
const y = ({ className: e, text: s, children: n, tooltipTheme: i = "default" }) => {
  const o = v(), [c, u] = b(!0);
  return g(() => {
    const { tooltipDOM: r } = o.current, m = ({ target: a }) => {
      var f;
      const { offsetWidth: x, scrollWidth: p } = a;
      x < p ? (f = o.current) == null || f.showTooltip() : u(!1);
    }, d = () => {
      var a;
      (a = o.current) == null || a.hideTooltip();
    };
    return r.addEventListener("mouseenter", m), r.addEventListener("mouseleave", d), () => {
      r.removeEventListener("mouseenter", m), r.removeEventListener("mouseleave", d);
    };
  }), /* @__PURE__ */ t.jsx(
    N,
    {
      ref: o,
      className: l("overflow-text-container", e),
      title: s,
      theme: i,
      tabIndex: c ? 0 : -1,
      trigger: "manual",
      children: n
    }
  );
}, A = ({ className: e, value: s }) => /* @__PURE__ */ t.jsx("span", { className: l("badge-container", e), children: s });
function E({
  text: e,
  value: s,
  data: n,
  icon: i,
  targetFunction: o,
  onMenuOptionSelected: c,
  className: u
}) {
  const r = () => {
    o(s, n), c(s);
  };
  return /* @__PURE__ */ t.jsxs(
    "div",
    {
      className: l("menu-option", u),
      onClick: () => r(),
      children: [
        /* @__PURE__ */ t.jsx("div", { className: "menu-option-icon", children: i && /* @__PURE__ */ t.jsx(h, { icon: i }) }),
        /* @__PURE__ */ t.jsx("div", { className: "menu-option-text", children: e })
      ]
    }
  );
}
class C {
  constructor(s, n, i, o) {
    this.text = s, this.icon = n, this.targetFunction = i, this.id = o;
  }
}
function I({ menuOptionSpecs: e, rowValues: s, rowData: n, className: i }) {
  const [o, c] = b(!1), u = () => {
    c(!o);
  }, r = () => {
    c(!1);
  }, m = v();
  T(m, () => {
    c(!1);
  });
  const d = e.map((a, x) => {
    const p = a instanceof C, f = x.toString() + (a == null ? void 0 : a.text);
    return p && /* @__PURE__ */ t.jsx(
      E,
      {
        value: s,
        data: n,
        onMenuOptionSelected: r,
        ...a
      },
      f
    );
  });
  return /* @__PURE__ */ t.jsxs("div", { className: l("action-menu", i), ref: m, children: [
    o && /* @__PURE__ */ t.jsx("div", { className: l("action-menu-options"), children: d }),
    /* @__PURE__ */ t.jsx(
      "button",
      {
        className: "action-menu-trigger",
        onClick: () => u(),
        children: /* @__PURE__ */ t.jsx(
          h,
          {
            icon: ["fa-regular", "fa-ellipsis-vertical"],
            className: "action-menu-trigger-icon"
          }
        )
      }
    )
  ] });
}
function D({ leftSection: e, rightSection: s }) {
  return /* @__PURE__ */ t.jsxs("div", { className: "button-bar", children: [
    e,
    s
  ] });
}
export {
  I as A,
  A as B,
  R as C,
  M as H,
  E as M,
  y as O,
  C as a,
  D as b
};
